module.exports = __webpack_public_path__ + "img/home_stack.d780da0f.webp";